var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('dv-border-box-7',{staticClass:"message"},[_vm._v(" 无法直接访问，请通过后台打开驾驶舱 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }